export default "__VITE_ASSET__DeVph9Io__"